import axiosInstance from './AxiosInstance';

export function getHotels(state=null) {
    return axiosInstance.get(`hotels?state=${state}`);
}

export function createHotel(hotelData) {
    return axiosInstance.post(`/hotels`, hotelData);
}

export function updateHotel(hotelData) {
    return axiosInstance.put(`/hotels/${hotelData.id}`, hotelData);
}


export function getHotelCategory(hotel_id) {
    return axiosInstance.get(`/hotel-roomcategories/${hotel_id}`);
}


export function deleteHotels(hotelId) {
    return axiosInstance.delete(`/hotels/${hotelId}`);
}
